<template>
  <ToggleGroupRoot
    v-model="selectedVisibility"
    type="single"
    :class="
      cn(
        'flex max-md:flex-col md:items-center md:justify-center gap-2',
        props.class
      )
    "
  >
    <ToggleGroupItem
      v-for="visibility in visibilities"
      :key="visibility"
      :as="Button"
      :value="visibility"
      :label="$t(`components.visibility.${visibility}`)"
      variant="secondary"
      type="gray"
      :aria-label="$t(`components.visibility.${visibility}`)"
      :class="[
        'md:w-40 md:h-24 py-2',
        {
          '!button-secondary-gray-fg !border-utility-gray-400 !bg-utility-gray-50':
            selectedVisibility === visibility,
        },
      ]"
    />
  </ToggleGroupRoot>
</template>

<script setup>
import { computed, ref } from "vue";
import { ToggleGroupItem, ToggleGroupRoot } from "radix-vue";
import { Button } from "@/SharedComponents/Buttons";
import { cn } from "@/Utils/cn";

const emit = defineEmits(["submit"]);

const props = defineProps({
  initialState: {
    type: String,
    validator: (value) => ["private", "public"].includes(value),
    required: true,
  },
  class: { type: null, required: false },
});

const selectedVisibility = ref(props.initialState);

const visibilities = ["private", "public"];

const isDirty = computed(() => {
  return selectedVisibility.value !== props.initialState;
});

function reset() {
  selectedVisibility.value = props.initialState;
}

function submit() {
  if (!isDirty.value) {
    return;
  }
  emit("submit", selectedVisibility.value);
}

defineExpose({
  isDirty,
  reset,
  submit,
});
</script>
